(() => {
  if (customElements.get('lgd-delivery-guide')) return;
  class DeliveryGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.region = this.querySelector('[data-delivery-region]');
      this.rural = this.querySelector('[data-delivery-rural]');
      this.labels = JSON.parse(this.querySelector('[data-delivery-labels]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency',currency:'NZD',currencyDisplay:'narrowSymbol'});
      try {
        const saved = JSON.parse(sessionStorage.getItem('lgd_delivery_choice') || 'null');
        if (saved && Array.from(this.region.options).some(option => option.value === saved.region)) {
          this.region.value = saved.region;
          this.rural.checked = saved.rural === true;
        }
      } catch (_) {}
      this.onChange = () => {
        try { sessionStorage.setItem('lgd_delivery_choice',JSON.stringify({region:this.region.value,rural:this.rural.checked})); } catch (_) {}
        this.render();
        document.querySelectorAll('lgd-delivery-guide').forEach(guide => {
          if (guide !== this && guide.ready) {
            guide.region.value = this.region.value;
            guide.rural.checked = this.rural.checked;
            guide.render();
          }
        });
      };
      this.region.addEventListener('change',this.onChange);
      this.rural.addEventListener('change',this.onChange);
      this.render();
      if (this.dataset.deliveryContext === 'cart') {
        const total = this.closest('[data-cart-total]');
        this.cartObserver = new MutationObserver(() => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refreshCart(),150);
        });
        total?.querySelectorAll('.cart-total-subtotal,.cart-total-grandtotal').forEach(node => {
          this.cartObserver.observe(node,{childList:true,subtree:true,characterData:true});
        });
      }
    }
    disconnectedCallback() {
      this.region?.removeEventListener('change',this.onChange);
      this.rural?.removeEventListener('change',this.onChange);
      this.cartObserver?.disconnect();
      clearTimeout(this.refreshTimer);
      this.refreshRequest?.abort();
      this.ready = false;
    }
    async refreshCart() {
      this.refreshRequest?.abort();
      this.refreshRequest = new AbortController();
      const status = this.querySelector('[data-delivery-status]');
      status.hidden = false;
      status.textContent = this.labels.updating;
      this.querySelector('[data-delivery-result]').hidden = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id',this.dataset.deliverySection);
        const response = await fetch(url,{signal:this.refreshRequest.signal,cache:'no-store'});
        if (!response.ok) throw new Error('Delivery guide unavailable');
        const markup = new DOMParser().parseFromString(await response.text(),'text/html');
        const next = markup.querySelector('lgd-delivery-guide');
        if (!next) throw new Error('Delivery guide missing');
        next.querySelector('details').open = this.querySelector('details').open;
        if (this.isConnected) this.replaceWith(next);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          status.textContent = this.labels.refresh_error;
        }
      }
    }
    format(cents) { return 'NZ' + this.money.format(cents / 100); }
    text(key,price) { return this.labels[key].replace('__price__',price); }
    render() {
      const option = this.region.selectedOptions[0];
      const result = this.querySelector('[data-delivery-result]');
      const contact = this.querySelector('[data-delivery-contact]');
      const estimate = this.querySelector('[data-delivery-estimate]');
      const rates = this.querySelector('[data-delivery-rates]');
      const bulky = this.querySelector('[data-delivery-bulky]');
      result.hidden = !option.value || option.value === 'other';
      contact.hidden = option.value !== 'other';
      bulky.hidden = true;
      if (!option.value || option.value === 'other') {
        return;
      }
      const extra = this.rural.checked ? Number(this.dataset.deliveryRuralExtra) : 0;
      const standard = Number(option.dataset.standard) + extra;
      const oversize = Number(option.dataset.oversize) + extra;
      const threshold = Number(option.dataset.threshold);
      const subtotal = Number(this.dataset.deliverySubtotal);
      const weight = Number(this.dataset.deliveryWeight);
      const useCart = this.dataset.deliveryContext === 'cart' && this.dataset.deliveryCurrency === 'NZD' && this.dataset.deliveryMixed !== 'true';
      const weightGap = weight > 99000 && weight < 100000;
      const showEstimate = useCart && !weightGap;
      estimate.hidden = !showEstimate;
      rates.hidden = showEstimate;
      this.querySelector('[data-delivery-standard]').textContent = this.format(standard);
      this.querySelector('[data-delivery-oversize]').textContent = this.format(oversize);
      const progress = this.querySelector('[data-delivery-progress]');
      if (showEstimate) {
        const qualified = subtotal >= threshold;
        const fee = qualified ? extra : (weight >= 100000 ? oversize : standard);
        const price = fee === 0 ? this.labels.free : this.format(fee);
        this.querySelector('[data-delivery-price]').textContent = price;
        progress.textContent = qualified
          ? (this.rural.checked ? this.labels.rural_qualified : this.labels.qualified)
          : this.text('remaining',this.format(threshold - subtotal));
        progress.textContent += ' ' + this.labels.basis;
        bulky.hidden = weight < 100000;
      } else {
        progress.textContent = this.text('threshold',this.format(threshold)) + ' ' + this.labels.guide;
        bulky.hidden = false;
      }
    }
  }
  customElements.define('lgd-delivery-guide',DeliveryGuide);
})();


